import React from 'react';
import { Link, useLocation } from 'react-router';
import { useTheme } from '../../context/ThemeContext.jsx';

const Header = () => {
  const { colors, spacing, fonts } = useTheme();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  if (isHomePage) return null;

  const headerStyles = {
    background: `${colors.surface}F2`,
    backdropFilter: 'blur(10px)',
    padding: `${spacing.scale.md} 0`,
    borderBottom: `1px solid ${colors.border}`,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    width: '100%',
    zIndex: 1000,
    transition: 'all 0.3s ease',
  };

  const headerContentStyles = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: `0 ${spacing.scale.lg}`,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  };

  const logoStyles = {
    height: '40px',
    width: '44px',
    marginRight: spacing.scale.md,
    objectFit: 'contain',
  };

  const titleStyles = {
    fontSize: fonts.sizes.xl.desktop,
    fontWeight: fonts.weights.semibold,
    color: colors.text,
    fontFamily: fonts.families.secondary,
    transition: 'color 0.3s ease',
  };

  return (
    <>
      <header style={headerStyles}>
        <div style={headerContentStyles}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
            <img src="/assets/logo.png" alt="Victoria Londe" style={logoStyles} />
            <span
              style={titleStyles}
              onMouseEnter={(e) => (e.currentTarget.style.color = colors.primaryLight)}
              onMouseLeave={(e) => (e.currentTarget.style.color = colors.text)}
            >
              Victoria Londe
            </span>
          </Link>
        </div>
      </header>
      <div style={{ height: '72px' }} />
    </>
  );
};

export default Header;
